// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Wj2o","bigColWidth":"Table_bigColWidth__2AjHH","biggerColWidth":"Table_biggerColWidth__Ig9g3","row":"Table_row__D1KhZ","col":"Table_col__831Zx"};